import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { VendorOrdersPage } from '@/components/VendorOrders/VendorOrdersPage'
import { vendorOrderSearchSchema, withoutSearchDefaults } from '@/components/VendorOrders/search'
import { inPageSearch } from '@/lib/searchNavigation'

/**
 * Wiring only.
 *
 * The search schema and the default-pruning live beside the page, so imports
 * point one way (`components → routes`) and this file holds no logic to leave
 * untested.
 */
export const Route = createFileRoute('/_app/operations/vendor-orders/')({
  validateSearch: vendorOrderSearchSchema,
  component: VendorOrdersRoute,
})

function VendorOrdersRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <VendorOrdersPage
      search={search}
      // Filtering and paging replace; opening a record is going somewhere, so
      // it pushes and the back button closes it. Either way the scroll stays.
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutSearchDefaults, next, options))
      }
    />
  )
}
